<template>
  <section class="school-tariffs">
    <div class="school-tariffs__header">
      <h3>тарифы домашней школы</h3>

      <div
        v-if="!ceny2Page"
        class="switcher"
      >
        <p>оплата:</p>

        <div class="switcher__buttons">
          <button
            :class="['switcher__button', { 'switcher__button--active': payVariant === 'month' }]"
            @click="payVariant = 'month'"
          >
            {{ SWITCH_ITEMS.month }}
          </button>
          <button
            :class="['switcher__button', { 'switcher__button--active': payVariant === 'year' }]"
            @click="payVariant = 'year'"
          >
            {{ SWITCH_ITEMS.year }}

            <span>-10%</span>
          </button>
        </div>
      </div>
    </div>

    <div class="school-tariffs__buttons">
      <button
        v-for="button in buttons"
        :key="button.class"
        :class="['m-btn', { active: currentClass === button.class }]"
        @click="currentClass = button.class"
      >
        {{ button.class }} класс
      </button>
    </div>

    <div class="school-tariffs__items">
      <div class="school-tariffs__item tariff">
        <span class="tariff__badge">
          рекомендуем
        </span>

        <div class="tariff__cheap">
          <span class="tariff__cheap--orange">до 25 уч-ков</span>
          <span>
            ФГОС
            <img
              src="/v2/school-new/tariff2/fgos.svg"
              alt="ФГОС"
            >
          </span>
        </div>

        <h3 class="tariff__title">
          премиум
        </h3>
        <h5
          v-if="premiumSwitch"
          class="tariff__subtitle"
        >
          максимум заботы и&nbsp;поддержки в&nbsp;обучении:
          успехи&nbsp;ребенка — наша ответственность
        </h5>
        <h5
          v-else
          class="tariff__subtitle"
        >
          индивидуальный маршрут: максимум времени для&nbsp;спорта,
          творчества и&nbsp;самореализации
        </h5>

        <div class="tariff__price">
          <s v-if="payVariant === 'year'">{{ premiumOldPrice | prettyCurrency }}</s>
          <h6>
            {{ premiumPrice | prettyCurrency(false) }}
            <span>₽{{ payVariant === 'month' ? '/мес' : '' }}</span>
          </h6>
          <p v-if="payVariant === 'month'">
            рассрочка на 12 месяцев без переплат
          </p>
          <p v-else>
            экономия <span>{{ (premiumOldPrice - premiumPrice) | prettyCurrency }}</span>
          </p>
        </div>

        <button
          class="m-btn tariff__button"
          @click="openModal(MODAL_TYPES.premium)"
        >
          оставить заявку
        </button>

        <ul class="tariff__list">
          <li>
            своя платформа с интерактивными уроками, конспектами,
            тренажерами&nbsp;и&nbsp;симуляторами
          </li>
          <li>ДЗ с&nbsp;авто- и&nbsp;ручной проверкой</li>
          <li><span>развернутый</span> отчет об&nbsp;успеваемости</li>
          <li>чат&nbsp;поддержки по&nbsp;ДЗ</li>
          <li>классный руководитель</li>
          <li><span>зачисляем в контингент</span> московской школы</li>
          <li><span>московский аттестат</span> гос. образца</li>
          <!--<li>персональный куратор</li>-->
          <li>психолог (до&nbsp;10&nbsp;встреч в&nbsp;год)</li>
          <li>профориентация: индивидуальная карта развития талантов и&nbsp;компетенций</li>
        </ul>

        <div
          :class="['tariff__switcher tariff__switcher--orange', {
            'tariff__switcher--active': premiumSwitch,
          }]"
          @click="premiumSwitch = !premiumSwitch"
        >
          <div class="tariff__switcher_action">
            <p>семейная форма</p>
            <button
              class="m-btn"
              @click.stop="premiumSwitch = !premiumSwitch"
            >
              <span />
            </button>
            <p>заочная форма</p>
          </div>
          <ul class="tariff__list">
            <li>ваш ребенок под контролем школы: задания, сроки, отличные оценки</li>
          </ul>
        </div>
      </div>

      <div class="school-tariffs__item tariff">
        <span
          v-if="comfortSwitch"
          class="tariff__badge"
        >
          популярно
        </span>

        <div class="tariff__cheap">
          <span class="tariff__cheap--violet">вебинары</span>
          <span>
            ФГОС
            <img
              src="/v2/school-new/tariff2/fgos.svg"
              alt="ФГОС"
            >
          </span>
        </div>

        <h3 class="tariff__title">
          комфорт
        </h3>
        <h5 class="tariff__subtitle">
          школьная программа без&nbsp;стресса: мы&nbsp;учим,
          вы&nbsp;наблюдаете за&nbsp;успехами
        </h5>

        <div class="tariff__price">
          <s v-if="payVariant === 'year'">{{ comfortOldPrice | prettyCurrency }}</s>
          <h6>
            {{ comfortPrice | prettyCurrency(false) }}
            <span>₽{{ payVariant === 'month' ? '/мес' : '' }}</span>
          </h6>
          <p v-if="payVariant === 'month'">
            рассрочка на 12 месяцев без переплат
          </p>
          <p v-else>
            экономия <span>{{ (comfortOldPrice - comfortPrice) | prettyCurrency }}</span>
          </p>
        </div>

        <button
          class="m-btn tariff__button"
          @click="openModal(MODAL_TYPES.comfort)"
        >
          оставить заявку
        </button>

        <ul class="tariff__list">
          <li>
            своя платформа с интерактивными уроками,
            конспектами, тренажерами&nbsp;и&nbsp;симуляторами
          </li>
          <li>ДЗ с&nbsp;авто- и&nbsp;ручной проверкой</li>
          <li>автоматический отчет об&nbsp;успеваемости</li>
          <li>чат&nbsp;поддержки по&nbsp;ДЗ</li>
          <li>классный руководитель</li>
        </ul>

        <div
          :class="['tariff__switcher tariff__switcher--violet', {
            'tariff__switcher--active': comfortSwitch,
          }]"
          @click="comfortSwitch = !comfortSwitch"
        >
          <div class="tariff__switcher_action">
            <p>прикрепиться к нашей школе</p>
            <button
              class="m-btn"
              @click.stop="comfortSwitch = !comfortSwitch"
            >
              <span />
            </button>
          </div>
          <ul
            v-if="comfortSwitch"
            class="tariff__list"
          >
            <li><span>зачисляем в контингент</span> московской школы</li>
            <li><span>московский аттестат</span> гос. образца</li>
          </ul>
          <ul
            v-else
            class="tariff__list"
          >
            <li>обучение <b>без</b> прикрепления</li>
            <li>справка о прохождении итоговой аттестации</li>
          </ul>
        </div>
      </div>

      <div class="school-tariffs__item tariff">
        <div class="tariff__cheap">
          <span>записи уроков</span>
          <span>
            ФГОС
            <img
              src="/v2/school-new/tariff2/fgos.svg"
              alt="ФГОС"
            >
          </span>
        </div>

        <h3 class="tariff__title">
          стандарт
        </h3>
        <h5 class="tariff__subtitle">
          полноценное обучение с фокусом на&nbsp;главном—&nbsp;успешной
          сдаче итоговой аттестации
        </h5>

        <div class="tariff__price">
          <s v-if="payVariant === 'year'">{{ standardOldPrice | prettyCurrency }}</s>
          <h6>
            {{ standardPrice | prettyCurrency(false) }}
            <span>₽{{ payVariant === 'month' ? '/мес' : '' }}</span>
          </h6>
          <p v-if="payVariant === 'month'">
            рассрочка на 12 месяцев без переплат
          </p>
          <p v-else>
            экономия <span>{{ (standardOldPrice - standardPrice) | prettyCurrency }}</span>
          </p>
        </div>

        <button
          class="m-btn tariff__button"
          @click="openModal(MODAL_TYPES.standart)"
        >
          оставить заявку
        </button>

        <ul class="tariff__list">
          <li>
            своя платформа с интерактивными уроками, конспектами,
            тренажерами&nbsp;и&nbsp;симуляторами
          </li>
          <li>ДЗ с&nbsp;авто- и&nbsp;ручной проверкой</li>
          <li>автоматический отчет об&nbsp;успеваемости</li>
          <li class="tariff__list_item-red">
            обучение без прикрепления
          </li>
          <li>справка о прохождении итоговой аттестации</li>
        </ul>
      </div>

      <div class="school-tariffs__item tariff">
        <div class="tariff__cheap">
          <span>записи уроков</span>
          <span class="tariff__cheap--green">{{ externalCheapByClass[currentClass] }} класс</span>
          <span>
            ФГОС
            <img
              src="/v2/school-new/tariff2/fgos.svg"
              alt="ФГОС"
            >
          </span>
        </div>

        <h3 class="tariff__title">
          экстернат
        </h3>
        <h5 class="tariff__subtitle">
          специальная ускоренная программа,
          без&nbsp;сокращения школьной программы
        </h5>

        <div class="tariff__price">
          <s v-if="payVariant === 'year'">{{ externalOldPrice | prettyCurrency }}</s>
          <h6>
            {{ externalPrice | prettyCurrency(false) }}
            <span>₽{{ payVariant === 'month' ? '/мес' : '' }}</span>
          </h6>
          <p v-if="payVariant === 'month'">
            рассрочка на 12 месяцев без переплат
          </p>
          <p v-else>
            экономия <span>{{ (externalOldPrice - externalPrice) | prettyCurrency }}</span>
          </p>
        </div>

        <button
          class="m-btn tariff__button"
          @click="openModal(MODAL_TYPES.externat)"
        >
          оставить заявку
        </button>

        <ul class="tariff__list">
          <li>
            своя платформа с интерактивными уроками, конспектами,
            тренажерами&nbsp;и&nbsp;симуляторами
          </li>
          <li>ДЗ с&nbsp;автопроверкой</li>
          <li>автоматический отчет об&nbsp;успеваемости</li>
          <li>
            <span>московский аттестат</span> гос. образца

            <div class="tariff__tooltip">
              <button
                class="m-btn"
                @click="blurElem"
              >
                <img
                  src="/v2/school-new/tariff2/tooltip.svg"
                  alt="?"
                >
              </button>

              <p>
                При условии успешной сдачи ГИА от школы «Синергия» в Москве ученик получает
                <span>аттестат&nbsp;государственного образца</span>
              </p>
            </div>
          </li>
          <li>ускоренная программа: <span>2 класса за 1 год</span></li>
          <li>аттестация в&nbsp;онлайн формате</li>
        </ul>
      </div>
    </div>

    <div class="school-tariffs__banner">
      <h5>как&nbsp;учиться&nbsp;<span>бесплатно</span>?</h5>
      <p>
        скидки до&nbsp;100% для&nbsp;более 50&nbsp;льготных категорий
        и&nbsp;реферальная программа с&nbsp;бесплатным обучением
      </p>
      <b>до 100%</b>
      <button
        class="m-btn"
        @click="openModal(MODAL_TYPES.specialConditions)"
      >
        узнать больше
      </button>
    </div>

    <div class="school-tariffs__blocks">
      <div class="school-tariffs__block">
        <h6>налоговый вычет</h6>
        <p>
          сможете <span>вернуть 13%</span> от&nbsp;стоимости обучения
        </p>

        <img
          src="/v2/school-new/tariff2/nalog.png"
          alt="nalog"
        >
      </div>
      <div class="school-tariffs__block">
        <h6>беспроцентная рассрочка</h6>
        <p>
          разделим стоимость обучения на&nbsp;части <span>без&nbsp;переплат</span>
        </p>

        <img
          src="/v2/school-new/tariff2/banks.png"
          alt="banks"
        >
      </div>
      <div class="school-tariffs__block">
        <h6>материнский капитал</h6>
        <p>
          <span>поможем с&nbsp;оформлением</span> необходимых документов
        </p>

        <img
          src="/v2/school-new/tariff2/heart.png"
          alt="heart"
        >
      </div>
      <div class="school-tariffs__block">
        <h6>платите частями</h6>
        <p>
          <span>разбивайте оплату</span> на&nbsp;равные части от&nbsp;2&nbsp;до&nbsp;12&nbsp;месяцев
        </p>

        <img
          src="/v2/school-new/tariff2/split.svg"
          alt="split"
        >
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import { MODAL_TYPES } from '../common/AppHeader/data';

const SWITCH_ITEMS = {
  month: 'ежемесячно',
  year: 'за год',
};

export default {
  name: 'SchoolTariffs',

  props: {
    pageClass: {
      type: Number,
      default: 5,
    },
  },

  data: () => ({
    payVariant: 'month',
    currentClass: 5,
    premiumSwitch: true,
    comfortSwitch: true,
    buttons: [
      { class: 5 },
      { class: 6 },
      { class: 7 },
      { class: 8 },
      { class: 9 },
      { class: 10 },
      { class: 11 },
    ],
    priceByClass: {
      5: {
        month: {
          comfort: 7920,
          comfortAttach: 8750,
          premium: 24590,
          premiumFamily: 22775,
          standard: 3330,
          external: 11920,
        },
        year: {
          comfort: 85500,
          comfortOld: 95000,
          comfortAttach: 94500,
          comfortAttachOld: 105000,
          premium: 265590,
          premiumOld: 295100,
          premiumFamily: 245970,
          premiumFamilyOld: 273300,
          standard: 36000,
          standardOld: 40000,
          external: 129240,
          externalOld: 143600,
        },
      },
      6: {
        month: {
          comfort: 7920,
          comfortAttach: 8750,
          premium: 24590,
          premiumFamily: 22775,
          standard: 3330,
          external: 11920,
        },
        year: {
          comfort: 85500,
          comfortOld: 95000,
          comfortAttach: 94500,
          comfortAttachOld: 105000,
          premium: 265590,
          premiumOld: 295100,
          premiumFamily: 245970,
          premiumFamilyOld: 273300,
          standard: 36000,
          standardOld: 40000,
          external: 129240,
          externalOld: 143600,
        },
      },
      7: {
        month: {
          comfort: 7920,
          comfortAttach: 8750,
          premium: 24590,
          premiumFamily: 22775,
          standard: 3330,
          external: 11920,
        },
        year: {
          comfort: 85500,
          comfortOld: 95000,
          comfortAttach: 94500,
          comfortAttachOld: 105000,
          premium: 265590,
          premiumOld: 295100,
          premiumFamily: 245970,
          premiumFamilyOld: 273300,
          standard: 36000,
          standardOld: 40000,
          external: 129240,
          externalOld: 143600,
        },
      },
      8: {
        month: {
          comfort: 7920,
          comfortAttach: 8750,
          premium: 24590,
          premiumFamily: 22775,
          standard: 3330,
          external: 13335,
        },
        year: {
          comfort: 85500,
          comfortOld: 95000,
          comfortAttach: 94500,
          comfortAttachOld: 105000,
          premium: 265590,
          premiumOld: 295100,
          premiumFamily: 245970,
          premiumFamilyOld: 273300,
          standard: 36000,
          standardOld: 40000,
          external: 144000,
          externalOld: 160000,
        },
      },
      9: {
        month: {
          comfort: 11085,
          comfortAttach: 12085,
          premium: 27250,
          premiumFamily: 24585,
          standard: 4170,
          external: 13335,
        },
        year: {
          comfort: 119700,
          comfortOld: 133000,
          comfortAttach: 130500,
          comfortAttachOld: 145000,
          premium: 295020,
          premiumOld: 327800,
          premiumFamily: 265590,
          premiumFamilyOld: 295100,
          standard: 45000,
          standardOld: 50000,
          external: 144000,
          externalOld: 160000,
        },
      },
      10: {
        month: {
          comfort: 11085,
          comfortAttach: 12085,
          premium: 27250,
          premiumFamily: 24585,
          standard: 4170,
          external: 15000,
        },
        year: {
          comfort: 119700,
          comfortOld: 133000,
          comfortAttach: 130500,
          comfortAttachOld: 145000,
          premium: 295020,
          premiumOld: 327800,
          premiumFamily: 265590,
          premiumFamilyOld: 295100,
          standard: 45000,
          standardOld: 50000,
          external: 162000,
          externalOld: 180000,
        },
      },
      11: {
        month: {
          comfort: 12670,
          comfortAttach: 13920,
          premium: 27250,
          premiumFamily: 24585,
          standard: 5000,
          external: 15000,
        },
        year: {
          comfort: 136800,
          comfortOld: 152000,
          comfortAttach: 150300,
          comfortAttachOld: 167000,
          premium: 295020,
          premiumOld: 327800,
          premiumFamily: 265590,
          premiumFamilyOld: 295100,
          standard: 54000,
          standardOld: 60000,
          external: 162000,
          externalOld: 180000,
        },
      },
    },
    externalCheapByClass: {
      5: '5-6',
      6: '6-7',
      7: '7-8',
      8: '8-9',
      9: '8-9',
      10: '10-11',
      11: '10-11',
    },

    MODAL_TYPES,
    SWITCH_ITEMS,
  }),

  computed: {
    currentPrice() {
      return this.priceByClass[this.currentClass][this.payVariant];
    },
    comfortPrice() {
      if (this.comfortSwitch) {
        return this.currentPrice.comfortAttach;
      }

      return this.currentPrice.comfort;
    },
    comfortOldPrice() {
      if (this.comfortSwitch) {
        return this.currentPrice.comfortAttachOld;
      }

      return this.currentPrice.comfortOld;
    },
    premiumPrice() {
      if (this.premiumSwitch) {
        return this.currentPrice.premium;
      }

      return this.currentPrice.premiumFamily;
    },
    premiumOldPrice() {
      if (this.premiumSwitch) {
        return this.currentPrice.premiumOld;
      }

      return this.currentPrice.premiumFamilyOld;
    },
    standardPrice() {
      return this.currentPrice.standard;
    },
    standardOldPrice() {
      return this.currentPrice.standardOld;
    },
    externalPrice() {
      return this.currentPrice.external;
    },
    externalOldPrice() {
      return this.currentPrice.externalOld;
    },

    ceny2Page() {
      return this.$route?.name === 'online-school-ceny-2'
        || this.$route?.name === 'online-school-ceny-dubai'
        || this.$route?.name === 'online-school-ceny-3'
        || this.$route?.name === 'online-school-semeinoe-obuchenie-ceny';
    },
  },

  created() {
    this.currentClass = this.pageClass;
  },

  methods: {
    ...mapActions('appHeaderModals', {
      storyOpenModal: 'openModal',
      storySetModalComment: 'setModalComment',
    }),

    openModal(modalType, cenyComment) {
      if (this.ceny2Page) {
        this.storyOpenModal(MODAL_TYPES.freeConsult);
        this.storySetModalComment(cenyComment);
        return;
      }

      this.storySetModalComment(`класс: ${this.currentClass} / форма обучения: ${SWITCH_ITEMS[this.payVariant]}`);
      this.storyOpenModal(modalType);
    },

    blurElem(e) {
      setTimeout(() => {
        const button = e.target.closest('button');
        if (button) button.blur();
      }, 5000);
    },
  },
};
</script>

<style scoped lang="scss">

.school-tariffs  {
  position: relative;

  &__header {
    margin-bottom: calc(var(--scale) * 40);
    display: flex;
    justify-content: space-between;
    align-items: center;

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 12);
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: calc(var(--scale) * 22);
    }

    h3 {
      font-weight: 500;
      font-size: calc(var(--scale) * 86);
      line-height: 110%;
      letter-spacing: -0.04em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 44);
      }
    }
  }

  &__buttons {
    margin-bottom: calc(var(--scale) * 40);
    display: flex;
    align-items: center;
    gap: calc(var(--scale) * 8);
    overflow-x: auto;

    @include media-down($size-tablet) {
      margin-bottom: 0;
      gap: calc(var(--scale) * 2);
      margin-left: calc(-1 * var(--scale) * 16);
      width: calc(100% + var(--scale) * 32);
      padding-inline: calc(var(--scale) * 16);
    }

    &::-webkit-scrollbar {
      display: none;
    }

    button {
      padding: calc(var(--scale) * 32) calc(var(--scale) * 54);
      background-color: #FFFFFF;
      border-radius: calc(var(--scale) * 200);
      transition: 200ms;

      white-space: nowrap;
      font-weight: 500;
      font-size: calc(var(--scale) * 32);
      line-height: 110%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        padding: calc(var(--scale) * 9) calc(var(--scale) * 16);
        font-size: calc(var(--scale) * 16);
        letter-spacing: -0.02em;
      }

      @media (hover: hover) {
        &:not(.active):hover {
          color: #5237E6;
        }
      }

      &.active {
        background-color: #5237E6;
        color: #FFFFFF;
      }
    }
  }

  &__items {
    margin-bottom:  calc(var(--scale) * 40);
    height: calc(var(--scale) * 832);
    display: flex;
    gap: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      margin-bottom:  calc(var(--scale) * 16);
      height: calc(var(--scale) * 656);
      gap: calc(var(--scale) * 4);
      overflow-x: auto;
      margin-left: calc(-1 * var(--scale) * 16);
      width: calc(100% + var(--scale) * 32);
      padding: calc(var(--scale) * 20) calc(var(--scale) * 16) 0;
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }

  &__banner {
    margin-bottom:  calc(var(--scale) * 20);
    position: relative;
    height:  calc(var(--scale) * 192);
    background-image: url("/v2/school-new/tariff2/banner.webp");
    background-size: cover;
    border-radius:  calc(var(--scale) * 40);
    padding:  calc(var(--scale) * 24)  calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      margin-bottom:  calc(var(--scale) * 8);
      height:  calc(var(--scale) * 183);
      background-image: url("/v2/school-new/tariff2/banner-tablet.webp");
      border-radius:  calc(var(--scale) * 24);
      padding:  calc(var(--scale) * 11)  calc(var(--scale) * 14);
    }

    @include media-down($size-mobile) {
      background-image: url("/v2/school-new/tariff2/banner-mob.webp");
    }

    h5 {
      margin-bottom:  calc(var(--scale) * 6);
      font-weight: 500;
      font-size:  calc(var(--scale) * 64);
      line-height: 95%;
      letter-spacing: -0.02em;
      color: #092A48;

      @include media-down($size-tablet) {
        font-size:  calc(var(--scale) * 28);
      }

      span {
        color: #1193E6;
      }
    }

    p {
      max-width:  calc(var(--scale) * 580);
      font-weight: 500;
      font-size:  calc(var(--scale) * 20);
      line-height: 130%;
      color: #092A48;

      @include media-down($size-tablet) {
        max-width:  calc(var(--scale) * 333);
        font-size:  calc(var(--scale) * 16);
        letter-spacing: -0.02em;
      }
    }

    b {
      padding:  calc(var(--scale) * 8)  calc(var(--scale) * 16)  calc(var(--scale) * 10);
      position: absolute;
      left:  calc(var(--scale) * 583);
      bottom:  calc(var(--scale) * 22);
      z-index: 2;
      background-color: #1193E6;
      border-radius:  calc(var(--scale) * 20);
      transform: rotate(-4deg);

      font-weight: 500;
      font-size:  calc(var(--scale) * 48);
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.02em;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        padding:  calc(var(--scale) * 5)  calc(var(--scale) * 8)  calc(var(--scale) * 7);
        left:  calc(var(--scale) * 267);
        bottom:  calc(var(--scale) * 51);
        border-radius:  calc(var(--scale) * 10);
        font-size:  calc(var(--scale) * 20);
      }
    }

    button {
      position: absolute;
      top:  calc(var(--scale) * 44);
      right:  calc(var(--scale) * 44);
      padding:  calc(var(--scale) * 34)  calc(var(--scale) * 56);
      background-color: #FF5319;
      border-radius:  calc(var(--scale) * 24);

      font-weight: 500;
      font-size:  calc(var(--scale) * 32);
      line-height: 110%;
      color: #FFFFFF;

      @media (hover: hover) {
        &:hover {
          background-color: #FF9C12;
        }
      }

      @include media-down($size-tablet) {
        padding:  calc(var(--scale) * 17)  calc(var(--scale) * 110);
        right: auto;
        top: auto;
        left:  calc(var(--scale) * 8);
        bottom:  calc(var(--scale) * 8);
        border-radius:  calc(var(--scale) * 16);
        font-size:  calc(var(--scale) * 18);
        line-height: 120%;
      }
    }
  }

  &__blocks {
    display: flex;
    gap:  calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      gap:  calc(var(--scale) * 8);
    }

    @include media-down($size-mobile) {
      flex-wrap: wrap;
    }
  }

  &__block {
    width: 100%;
    height:  calc(var(--scale) * 192);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    padding:  calc(var(--scale) * 24)  calc(var(--scale) * 30);
    background-color: #FFFFFF;
    border-radius:  calc(var(--scale) * 40);

    @include media-down($size-tablet) {
      height:  calc(var(--scale) * 128);
      padding:  calc(var(--scale) * 12)  calc(var(--scale) * 11)  calc(var(--scale) * 12)  calc(var(--scale) * 16);
      border-radius:  calc(var(--scale) * 24);
      justify-content: flex-start;
      gap:  calc(var(--scale) * 2);
    }

    @include media-down($size-mobile) {
      width: calc(50% -  calc(var(--scale) * 4));
    }

    h6 {
      font-weight: 500;
      font-size:  calc(var(--scale) * 32);
      line-height: 110%;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size:  calc(var(--scale) * 18);
        letter-spacing: -0.02em;
      }
    }

    p {
      max-width:  calc(var(--scale) * 260);
      font-weight: 500;
      font-size:  calc(var(--scale) * 16);
      line-height: 130%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        max-width:  calc(var(--scale) * 151);
        font-size:  calc(var(--scale) * 12);
      }

      span {
        color: #02120F;
      }
    }

    img {
      position: absolute;
      width:  calc(var(--scale) * 70);
      right:  calc(var(--scale) * 8);
      bottom:  calc(var(--scale) * 8);

      @include media-down($size-tablet) {
        width:  calc(var(--scale) * 40);
      }
    }

    &:last-child img {
      width: auto;
      height:  calc(var(--scale) * 60);

      @include media-down($size-tablet) {
        height:  calc(var(--scale) * 40);
      }
    }

    &:nth-child(2) img {
      @include media-down($size-tablet) {
        width:  calc(var(--scale) * 32);
      }
    }
  }
}

.switcher {
  display: flex;
  align-items: center;
  gap: calc(var(--scale) * 12);

  @include media-down($size-tablet) {
    gap: calc(var(--scale) * 8);
  }

  p {
    font-weight: 500;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 18);
    }
  }

  &__buttons {
    display: flex;
    align-items: center;
    padding: calc(var(--scale) * 4);
    gap: calc(var(--scale) * 2);
    background-color: #FFFFFF;
    border-radius: calc(var(--scale) * 18);

    @include media-down($size-tablet) {
      padding:  calc(var(--scale) * 2);
      border-radius:  calc(var(--scale) * 10);
    }
  }

  &__button {
    position: relative;
    padding:  calc(var(--scale) * 10)  calc(var(--scale) * 24)  calc(var(--scale) * 12);
    border-radius:  calc(var(--scale) * 14);
    background: none;
    border: none;
    cursor: pointer;
    transition: 200ms;

    font-style: normal;
    font-weight: 500;
    font-size:  calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      padding:  calc(var(--scale) * 7)  calc(var(--scale) * 16)  calc(var(--scale) * 8);
      border-radius:  calc(var(--scale) * 10);
      font-size:  calc(var(--scale) * 16);
    }

    @media (hover: hover) {
      &:hover {
        color: #02120F;
      }
    }

    &--active {
      background-color: #5237E6;
      color: #FFFFFF !important;
    }

    span {
      padding:  calc(var(--scale) * 4)  calc(var(--scale) * 8);
      position: absolute;
      right:  calc(-1 * var(--scale) * 16);
      top:  calc(-1 * var(--scale) * 16);
      background-color: #22AE73;
      border-radius:  calc(var(--scale) * 40);
      transform: rotate(12deg);

      font-weight: 500;
      font-size:  calc(var(--scale) * 14);
      line-height: 130%;
      color: #FFFFFF;

      @include media-down($size-tablet) {
        top:  calc(-1 * var(--scale) * 12);
        right:  calc(-1 * var(--scale) * 14);
        padding:  calc(var(--scale) * 3)  calc(var(--scale) * 7);
        font-size:  calc(var(--scale) * 12);
      }
    }
  }
}

.tariff {
  flex-shrink: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  width:  calc(var(--scale) * 445);
  background-color: #FFFFFF;
  border-radius:  calc(var(--scale) * 40);
  padding:  calc(var(--scale) * 20);

  @include media-down($size-tablet) {
    width:  calc(var(--scale) * 352);
    border-radius:  calc(var(--scale) * 24);
    padding:  calc(var(--scale) * 16)  calc(var(--scale) * 8)  calc(var(--scale) * 8);
  }

  &__badge {
    padding:  calc(var(--scale) * 5)  calc(var(--scale) * 14)  calc(var(--scale) * 6);
    position: absolute;
    right: 0;
    top:  calc(-1 * var(--scale) * 10);
    background-color: #187D24;
    border-radius:  calc(var(--scale) * 40);

    font-weight: 500;
    font-size:  calc(var(--scale) * 16);
    line-height: 130%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      top:  calc(-1 * var(--scale) * 8);
      font-size:  calc(var(--scale) * 14);
    }
  }

  &__cheap {
    display: flex;
    gap:  calc(var(--scale) * 2);
    margin-bottom:  calc(var(--scale) * 8);

    @include media-down($size-tablet) {
      padding-inline:  calc(var(--scale) * 8);
    }

    span {
      display: flex;
      align-items: center;
      gap:  calc(var(--scale) * 5);
      padding: 0  calc(var(--scale) * 14);
      height:  calc(var(--scale) * 32);
      background-color: #ECEDF0;
      border-radius:  calc(var(--scale) * 40);

      font-weight: 500;
      font-size:  calc(var(--scale) * 16);
      line-height: 130%;
      color: #02120F;

      @include media-down($size-tablet) {
        height:  calc(var(--scale) * 30);
        font-size:  calc(var(--scale) * 14);
      }

      &:has(img) {
        padding-right:  calc(var(--scale) * 5);
      }

      &.tariff__cheap--orange {
        color: #FF5319;
        background-color: #FFE6D4;
      }

      &.tariff__cheap--violet {
        color: #5036CC;
        background-color: #E0E4FF;
      }

      &.tariff__cheap--green {
        color: #187D24;
        background-color: #DDFBDF;
      }
    }
  }

  &__title {
    margin-bottom:  calc(var(--scale) * 2);
    font-weight: 500;
    font-size:  calc(var(--scale) * 48);
    line-height: 110%;
    letter-spacing: -0.02em;
    color: #02120F;

    @include media-down($size-tablet) {
      margin-bottom:  calc(var(--scale) * 8);
      padding-inline:  calc(var(--scale) * 8);
      font-size:  calc(var(--scale) * 28);
      line-height: 95%;
    }
  }

  &__subtitle {
    margin-bottom:  calc(var(--scale) * 49);
    font-weight: 500;
    font-size:  calc(var(--scale) * 16);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      margin-bottom:  calc(var(--scale) * 32);
      padding-inline:  calc(var(--scale) * 8);
      font-size:  calc(var(--scale) * 14);
    }
  }

  &__price {
    position: relative;
    margin-bottom:  calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      margin-bottom: calc(var(--scale) * 16);
      padding-inline: calc(var(--scale) * 8);
    }

    h6 {
      display: flex;
      align-items: flex-end;
      gap:  calc(var(--scale) * 4);

      font-weight: 500;
      font-size:  calc(var(--scale) * 48);
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom:  calc(var(--scale) * 2);
        font-size:  calc(var(--scale) * 28);
        line-height: 95%;
      }

      span {
        position: relative;
        bottom:  calc(var(--scale) * 4);
        font-weight: 500;
        font-size:  calc(var(--scale) * 26);
        line-height: 120%;
        color: #02120F;

        @include media-down($size-tablet) {
          bottom: 0;
          font-size:  calc(var(--scale) * 18);
        }
      }
    }

    p {
      font-weight: 500;
      font-size:  calc(var(--scale) * 16);
      line-height: 130%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size:  calc(var(--scale) * 14);
      }

      span {
        color: #5237E6;
        font-weight: 700;
      }

      &:has(span) {
        color: #02120F;
        //font-weight: 700;
      }
    }

    s {
      position: absolute;
      left: 0;
      top: calc(-1 * var(--scale) * 25);

      font-weight: 500;
      font-size: 16px;
      line-height: 130%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        left: calc(var(--scale) * 8);
        top: calc(-1 * var(--scale) * 20);
        font-size: 14px;
      }
    }
  }

  &__button {
    width: 100%;
    margin-bottom: calc(var(--scale) * 22);
    padding-block: calc(var(--scale) * 24);
    background-color: #FF5319;
    border-radius:  calc(var(--scale) * 24);

    font-weight: 500;
    font-size:  calc(var(--scale) * 26);
    line-height: 120%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      margin-bottom:  calc(var(--scale) * 16);
      padding-block:  calc(var(--scale) * 17);
      border-radius:  calc(var(--scale) * 16);
      font-size:  calc(var(--scale) * 18);
    }

    @media (hover: hover) {
      &:hover {
        background-color: #FF9C12;
      }
    }
  }

  &__list {
    display: flex;
    flex-direction: column;
    gap:  calc(var(--scale) * 8);

    @include media-down($size-tablet) {
      gap:  calc(var(--scale) * 6);
      padding-inline:  calc(var(--scale) * 8);
    }

    li {
      position: relative;
      display: flex;
      gap:  calc(var(--scale) * 8);
      font-weight: 500;
      font-size:  calc(var(--scale) * 14);
      line-height: 130%;
      color: #02120F;

      @include media-down($size-tablet) {
        gap:  calc(var(--scale) * 6);
        font-size:  calc(var(--scale) * 12);
      }

      span {
        color: #5237E6;
      }

      b {
        font-weight: 700;
      }

      &:before {
        content: '';
        flex-shrink: 0;
        display: block;
        margin-top:  calc(var(--scale) * 6);
        width:  calc(var(--scale) * 8);
        height:  calc(var(--scale) * 8);
        background-color: #5036CC;
        border-radius:  calc(var(--scale) * 2);

        @include media-down($size-tablet) {
          margin-top:  calc(var(--scale) * 5);
        }
      }
    }

    li.tariff__list_item-red {
      span {
        color: currentColor;
      }

      &:before {
        background-color: transparent;
        background-image: url("/v2/school-new/tariff2/x.svg");
        background-size: contain;
        background-repeat: no-repeat;
      }
    }
  }

  &__tooltip {
    button {
      position: absolute;
      top: 0;
      right: 0;

      img {
        width:  calc(var(--scale) * 20);
        height:  calc(var(--scale) * 20);
      }

      &:focus + p {
        display: block;
      }

      @media (hover: hover) {
        &:hover + p {
          display: block;
        }
      }
    }

    p {
      display: none;
      padding:  calc(var(--scale) * 16)  calc(var(--scale) * 20);
      position: absolute;
      z-index: 2;
      top:  calc(var(--scale) * 27);
      right: 0;
      width:  calc(var(--scale) * 346);
      background-color: #FFFFFF;
      border: 1px solid #ECEDF0;
      box-shadow:
        calc(var(--scale) * 10)  calc(var(--scale) * 10)  calc(var(--scale) * 22) rgba(7, 21, 57, 0.1),
        calc(var(--scale) * 4)  calc(var(--scale) * 4)  calc(var(--scale) * 14) rgba(7, 21, 57, 0.05);
      border-radius:  calc(var(--scale) * 24);

      font-weight: 500;
      font-size:  calc(var(--scale) * 14);
      line-height: 130%;
      color: #02120F;

      @include media-down($size-tablet) {
        padding:  calc(var(--scale) * 12)  calc(var(--scale) * 16);
        top:  calc(var(--scale) * 68);
        width:  calc(var(--scale) * 320);
        border-radius:  calc(var(--scale) * 16);
        font-size:  calc(var(--scale) * 12);
      }
    }
  }

  &__switcher {
    margin-top: auto;
    padding:  calc(var(--scale) * 16)  calc(var(--scale) * 20);

    background-color: #ECEDF0;
    border-radius:  calc(var(--scale) * 24);

    @include media-down($size-tablet) {
      padding:  calc(var(--scale) * 12)  calc(var(--scale) * 16);
      border-radius:  calc(var(--scale) * 16);
    }

    &_action {
      margin-bottom:  calc(var(--scale) * 8);
      display: flex;
      align-items: center;
      gap:  calc(var(--scale) * 10);

      p {
        width: 100%;
        font-weight: 500;
        font-size:  calc(var(--scale) * 16);
        line-height: 130%;
        color: #02120F;

        @include media-down($size-tablet) {
          font-size:  calc(var(--scale) * 14);
        }

        &:last-child {
          text-align: center;
        }
      }

      button {
        flex-shrink: 0;
        position: relative;
        padding:  calc(var(--scale) * 2);
        width:  calc(var(--scale) * 44);
        height:  calc(var(--scale) * 26);
        background-color: #A7ABAC;
        border-radius:  calc(var(--scale) * 50);
        transition: 200ms;

        span {
          width:  calc(var(--scale) * 22);
          height:  calc(var(--scale) * 22);
          position: absolute;
          top:  calc(var(--scale) * 2);
          left:  calc(var(--scale) * 2);
          background-color: #FFFFFF;
          border-radius:  calc(var(--scale) * 200);
          transform: translateX(0);
          transition: 200ms;
        }
      }
    }

    &--orange {
      button {
        background-color: #FF5319;
      }

      ul li {
        color: #A7ABAC;

        &:before {
          background-color: #A7ABAC;
        }
      }
    }

    &--active {
      button span {
        transform: translateX(calc(var(--scale) * 18));
      }

      &.tariff__switcher--violet {
        background-color: #E0E4FF;

        button {
          background-color: #5036CC;
        }
      }

      &.tariff__switcher--orange {
        background-color: #FFE6D4;

        ul li {
          color: #02120F;

          &:before {
            background-color: #FF5319;
          }
        }
      }
    }
  }
}

</style>
